export enum TrackerType {
  MEVO_TRACKER = 'MEVO_TRACKER',
}
